export type OutboundShipmentAlertType =
  | 'STUCK_IN_TRANSIT'
  | 'RETURNED_TO_SENDER'
  | 'FAILED_DELIVERY_ATTEMPT';

export type OutboundShipmentAlertPolicy = {
  type: OutboundShipmentAlertType;
  enabled: boolean;
  thresholdDays: number | null;
};

export type OutboundShipmentAlertSettings = {
  storeId: string;
  channel: 'INTERNAL_EMAIL';
  recipientUserIds: string[];
  recipientEmails: string[];
  policies: OutboundShipmentAlertPolicy[];
};

export type OutboundShipmentAlertFormState = Pick<
  OutboundShipmentAlertSettings,
  'recipientUserIds' | 'recipientEmails' | 'policies'
>;

export type OutboundShipmentAlertTeamMember = {
  id: string;
  displayName: string;
  email: string;
  role: string;
};

export const DEFAULT_OUTBOUND_SHIPMENT_ALERT_POLICIES: OutboundShipmentAlertPolicy[] =
  [
    {
      type: 'STUCK_IN_TRANSIT',
      enabled: false,
      thresholdDays: 7,
    },
    {
      type: 'RETURNED_TO_SENDER',
      enabled: false,
      thresholdDays: null,
    },
    {
      type: 'FAILED_DELIVERY_ATTEMPT',
      enabled: false,
      thresholdDays: null,
    },
  ];

export const DEFAULT_OUTBOUND_SHIPMENT_ALERT_FORM: OutboundShipmentAlertFormState =
  {
    recipientUserIds: [],
    recipientEmails: [],
    policies: DEFAULT_OUTBOUND_SHIPMENT_ALERT_POLICIES,
  };

export const normalizeOutboundShipmentAlertSettings = (
  settings?: OutboundShipmentAlertSettings | null,
): OutboundShipmentAlertFormState => {
  const policies = DEFAULT_OUTBOUND_SHIPMENT_ALERT_POLICIES.map(
    (defaultPolicy) => {
      const savedPolicy = settings?.policies?.find(
        (policy) => policy.type === defaultPolicy.type,
      );

      return {
        type: defaultPolicy.type,
        enabled: savedPolicy?.enabled ?? defaultPolicy.enabled,
        thresholdDays:
          defaultPolicy.type === 'STUCK_IN_TRANSIT'
            ? savedPolicy?.thresholdDays ?? defaultPolicy.thresholdDays
            : null,
      };
    },
  );

  return {
    recipientUserIds: [...(settings?.recipientUserIds || [])],
    recipientEmails: [...(settings?.recipientEmails || [])],
    policies,
  };
};
